const map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		[
			57265,
			73879
		]
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		[
			57265,
			71006
		]
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		[
			57265,
			46246
		]
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		[
			11450
		]
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		[
			57265,
			47147
		]
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		[
			57265,
			2003
		]
	],
	"./101/Spectate/SecondaryMenu.layout.js": [
		31883,
		[
			57265,
			61542
		]
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		[
			57265,
			44391
		]
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		[
			57265,
			40796
		]
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		[
			57265,
			58068
		]
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		[
			57265,
			22719
		]
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		[
			57265,
			46719
		]
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		[
			57265,
			74724
		]
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		[
			57265,
			79108
		]
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		[
			57265,
			63327
		]
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		[
			57265,
			88838
		]
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		[
			57265,
			82669,
			13022
		]
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		[
			57265,
			72522
		]
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		[
			57265,
			51845
		]
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		[
			57265,
			34635
		]
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		[
			57265,
			17484
		]
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		[
			57265,
			25290
		]
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		[
			57265,
			58919
		]
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		[
			57265,
			81288
		]
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		[
			57265,
			25290,
			37709
		]
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		[
			57265,
			25290,
			65883
		]
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		[
			57265,
			25290,
			49774
		]
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		[
			57265,
			87253
		]
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		[
			57265,
			68439
		]
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		[
			57265,
			55738
		]
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		[
			57265,
			53545
		]
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		[
			57265,
			82669,
			92593
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21871;
module.exports = webpackAsyncContext;